import React from "react";
import { Card } from "../card";
import { AddBlocks } from "./AddBlocks";
import { BlockList } from "./blockList/blockLists";
import { GridWrapper } from "../GridWrapper/GridWrapper";

export const BlocksComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add block">
              <div>
                <AddBlocks />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card
              wrapperStyle={{
                height: "100%",
              }}
              cardTitle="All blocks"
            >
              <div>
                <BlockList />
              </div>
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
